import styled from "styled-components";

import { InputFieldStyles } from "../styles";

export const StyledTextArea = styled.textarea`
  ${InputFieldStyles}
`;
